module.exports = __webpack_public_path__ + "img/icon_house.c2ebbf56.svg";